import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const ApplicationPage = () => {
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customerid');

  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Application Submitted Successfully | Trusted Trademark Filer</title>
        <meta name="description" content="Thank you for choosing Trusted Trademark Filer. Your trademark application has been successfully submitted and our team will contact you shortly." />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-br from-[#E2F8FE] to-white flex items-center justify-center py-12 px-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-2xl p-8 md:p-12 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-green-100 p-4 rounded-full">
            <CheckCircle className="h-16 w-16 text-green-600" />
          </div>
        </div>
        
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Thank You for Your Submission!
        </h1>
        
        <p className="text-xl text-gray-600 mb-6">
          Your trademark registration request has been received successfully.
        </p>
        
        {customerId && (
          <div className="bg-[#E2F8FE] rounded-lg p-6 mb-6">
            <p className="text-sm text-gray-600 mb-2">Your Customer ID</p>
            <p className="text-2xl font-bold text-[#FF4A2A]">{customerId}</p>
          </div>
        )}
        
        <div className="space-y-4 text-left bg-gray-50 rounded-lg p-6">
          <h2 className="text-lg font-bold text-gray-900 mb-3">What Happens Next?</h2>
          <div className="flex gap-3">
            <CheckCircle className="h-6 w-6 text-green-600 flex-shrink-0 mt-0.5" />
            <p className="text-gray-700">Our trademark experts will review your submission within 24 hours</p>
          </div>
          <div className="flex gap-3">
            <CheckCircle className="h-6 w-6 text-green-600 flex-shrink-0 mt-0.5" />
            <p className="text-gray-700">You'll receive a detailed email with next steps and pricing</p>
          </div>
          <div className="flex gap-3">
            <CheckCircle className="h-6 w-6 text-green-600 flex-shrink-0 mt-0.5" />
            <p className="text-gray-700">A dedicated case manager will be assigned to your application</p>
          </div>
        </div>
        
        <div className="mt-8">
          <a 
            href="/"
            className="inline-block bg-[#FF4A2A] hover:bg-[#E63E1F] text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-300"
          >
            Return to Home
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default ApplicationPage;
